import {Injectable} from '@angular/core';
import {GridIdentifier} from '@application/grids/grid-identifier.enum';
import {IdNameDescription} from '@domain/id-name-description';
import {HttpPlasticProductGroupsService} from '@infrastructure/http/plastic-product-group/http-plastic-product-groups.service';
import {
  CrudObjectSelectionDialogComponent,
  CrudObjectSelectionDialogInput,
  CrudOverviewDataBuilderFactoryService,
  CrudOverviewDataConfig,
  GridOptionsBuilder,
  NavigationHelperPrototypeService
} from '@vdw/angular-component-library';
import {Observable} from 'rxjs';
import {PlasticProductGroupOverviewService} from './plastic-product-group-overview.service';

@Injectable({providedIn: 'root'})
export class PlasticProductGroupSelectionService {
  private config: CrudOverviewDataConfig<IdNameDescription>;

  public constructor(
    private readonly plasticProductGroups: HttpPlasticProductGroupsService,
    private readonly overview: PlasticProductGroupOverviewService,
    private readonly navigationHelper: NavigationHelperPrototypeService,
    private readonly builderFactoryService: CrudOverviewDataBuilderFactoryService<IdNameDescription>
  ) {
    this.init();
  }

  public init(): void {
    this.config = this.builderFactoryService
      .getBuilder()
      .withEntityName('TEXTILE_DATA.PLASTIC_PRODUCT.PRODUCT_GROUP')
      .withRowData(this.plasticProductGroups.getAll())
      .withCrudGridOptions(this.overview.getColumnDefs(), GridIdentifier.PLASTIC_PRODUCT_GROUP_OVERVIEW, null, (builder: GridOptionsBuilder) =>
        this.overview.getDefaultGridOptionsBuilder(builder).withRowSelection(false, false).build()
      )
      .build();
  }

  public openContentSwitcherDialog(inputValue: IdNameDescription): Observable<IdNameDescription[]> {
    this.config.rowData = null;
    this.config.selectedObjects = [inputValue];

    return this.navigationHelper.navigateWithContentSwitcher<IdNameDescription[]>({
      componentInfo: {
        component: CrudObjectSelectionDialogComponent,
        componentInputs: {config: this.config} as CrudObjectSelectionDialogInput
      }
    });
  }
}
